var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5ZM14.2424 6.81345C14.4377 7.0087 14.4377 7.32528 14.2424 7.52054L10.9847 10.7781L14.2424 14.0357C14.4377 14.2309 14.4377 14.5475 14.2424 14.7428C14.0471 14.938 13.7305 14.938 13.5353 14.7428L10.2776 11.4852L7.02019 14.7425C6.82492 14.9377 6.50833 14.9377 6.31307 14.7425C6.1178 14.5472 6.1178 14.2306 6.31307 14.0354L9.57046 10.7781L6.31307 7.52084C6.1178 7.32558 6.1178 7.009 6.31307 6.81375C6.50833 6.61849 6.82492 6.61849 7.02019 6.81375L10.2776 10.071L13.5353 6.81345C13.7305 6.61819 14.0471 6.61819 14.2424 6.81345Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextCrossIcon);
export default __webpack_public_path__ + "static/media/text-cross-icon.407dac108ec71599ab9045421fc60a18.svg";
export { ForwardRef as ReactComponent };